import { c as _c } from "react/compiler-runtime";
import { classNames, Flex, TextBody } from "@opensea/ui-kit";
export function ItemCardPriceLabel(t0) {
  const $ = _c(14);
  const {
    label,
    size,
    component
  } = t0;
  const t1 = size || "sm";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      size: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const textProps = t2;
  const t3 = size === "xs" ? "flex-col" : "gap-1";
  let t4;
  if ($[2] !== t3) {
    t4 = classNames(t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== label || $[5] !== textProps) {
    t5 = label ? <TextBody {...textProps} className="text-text-secondary">{label}</TextBody> : null;
    $[4] = label;
    $[5] = textProps;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== component || $[8] !== textProps) {
    t6 = component ? <TextBody {...textProps} className="text-text-primary">{component}</TextBody> : null;
    $[7] = component;
    $[8] = textProps;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <Flex className={t4}>{t5}{t6}</Flex>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}